import React from 'react';
import Plot from 'react-plotly.js';



const LineChart = ({ chartDataJson }) => {

    if (!chartDataJson || !chartDataJson.data || !chartDataJson.layout) {
        return <div>Loading or no data available...</div>;
    }

    const { data, layout } = chartDataJson;


    return (
        <Plot
            data={data}
            layout={layout}
            config={{ responsive: false }}
            style={{ width: '100%', height: '100%' }}

        />
    )
};

export default LineChart;
